import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Container, Nav, NavItem, TabContent, TabPane, NavLink } from 'reactstrap';
import _ from 'lodash';
import classnames from 'classnames';
import UIControllerPage from './UIController';
import UIControllerImageLoader from './UIControllerImageLoader';
import UIControllerRunningExecutionsPage from './UIControllerRunningExecutions';
import UIControllerReport from './UIControllerReport';
import UIControllerRunTypes from './UIControllerRunTypes';


interface IUIControllerTabsProps extends RouteComponentProps<{ clientId?: string }> {};

interface IUIControllerTabsState {
    tab: string;
}

type TabName = 'uicontroller' |'report'| 'images' | 'executions' | 'runtypes'|'';

export default class UIControllerTabs extends React.Component<IUIControllerTabsProps, IUIControllerTabsState>{

    constructor(props: IUIControllerTabsProps) {
        super(props)
        this.state = {
            tab: 'uicontroller',
        }
    }

    selected = (tab: TabName) => this.state.tab === tab;

    toggle = (tab: TabName) => {
        if (this.state.tab !== tab) {
            this.setState({ tab })
        }
    }

    public render() {
        return (
            <Container>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.selected('uicontroller') })}
                            onClick={() => this.toggle('uicontroller')} to={''}>UI Controller</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.selected('images') })}
                            onClick={() => this.toggle('images')} to={''}>Image Loader</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.selected('executions') })}
                            onClick={() => this.toggle('executions')} to={''}>Running Excutions</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.selected('report') })}
                            onClick={() => this.toggle('report')} to={''}>Report</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.selected('runtypes') })}
                            onClick={() => this.toggle('runtypes')} to={''}>Run Types</NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.tab} className={this.state.tab}>
                    <TabPane tabId='uicontroller'>
                        <UIControllerPage  {...this.props} />
                    </TabPane>
                    <TabPane tabId='images'>
                        <UIControllerImageLoader />
                    </TabPane>
                    <TabPane tabId='executions'>
                        <UIControllerRunningExecutionsPage />
                    </TabPane>
                    <TabPane tabId='report'>
                        <UIControllerReport />
                    </TabPane>
                    <TabPane tabId='runtypes'>
                        <UIControllerRunTypes />
                    </TabPane>
                </TabContent>
            </Container>
        )
    }
}